/**
 *
 * DrillDown
 *
 */

import React, { Fragment, Component } from "react"
import { Tooltip, Spin } from "antd"
import { Icon } from "@ant-design/compatible"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';
import "./index.less"

var isEqual = function (value, other) { // eslint-disable-line
  // Get the value type
  const type = Object.prototype.toString.call(value)

  // If the two objects are not the same type, return false
  if (type !== Object.prototype.toString.call(other)) return false

  // If items are not an object or array, return false
  if (["[object Array]", "[object Object]"].indexOf(type) < 0) return false

  // Compare the length of the length of the two items
  const valueLen =
    type === "[object Array]" ? value.length : Object.keys(value).length
  const otherLen =
    type === "[object Array]" ? other.length : Object.keys(other).length
  if (valueLen !== otherLen) return false

  // Compare two items
  const compare = function (item1, item2) { // eslint-disable-line
    // Get the object type
    const itemType = Object.prototype.toString.call(item1)

    // If an object or array, compare recursively
    if (["[object Array]", "[object Object]"].indexOf(itemType) >= 0) {
      if (!isEqual(item1, item2)) return false
    }

    // Otherwise, do a simple comparison
    else {
      // If the two items are not the same type, return false
      if (itemType !== Object.prototype.toString.call(item2)) return false

      // Else if it's a function, convert to a string and compare
      // Otherwise, just compare
      if (itemType === "[object Function]") {
        if (item1.toString() !== item2.toString()) return false
      } else if (item1 !== item2) return false
    }
  }

  // Compare properties
  if (type === "[object Array]") {
    for (let i = 0; i < valueLen; i++) {
      if (compare(value[i], other[i]) === false) return false
    }
  } else {
    for (const key in value) {
      if (value.hasOwnProperty(key)) {
        if (compare(value[key], other[key]) === false) return false
      }
    }
  }

  // If nothing failed, return true
  return true
}
class WeekResponse extends Component {
  id = Math.random()
    .toString(36)
    .substr(2, 9)

  state = {
    leyendVisible: true,
    bars: [],
  }

  componentDidUpdate(prevProps) {
    const { dataAll, dataCurrent } = this.props
    const renderBar = dataCurrent.length > 0 ? dataCurrent : dataAll
    const renderBarCurrent =
      prevProps.dataCurrent.length > 0
        ? prevProps.dataCurrent
        : prevProps.dataAll
    if (!isEqual(renderBar, renderBarCurrent)) {
      this.setState({ bars: [] }, () => {
        this.setState(
          { bars: dataCurrent.length > 0 ? dataCurrent : dataAll },
          () => {
            this.reloadRows()
          }
        )
      })
    }
  }

  componentDidMount() {
    const { dataAll, dataCurrent } = this.props
    this.setState({ bars: [] }, () => {
      this.setState(
        { bars: dataCurrent.length > 0 ? dataCurrent : dataAll },
        () => {
          this.reloadRows()
        }
      )
    })
  }

  reloadRows = () => {
    const percentDivs = document.querySelectorAll(
      `#DrillDown_${this.id} .bar-percent`
    )
    percentDivs.forEach((percentDiv) => {
      const barPercent = Math.floor(percentDiv.textContent.replace("%", ""))
      percentDiv.parentNode.style.setProperty(
        "grid-row-start",
        101 - `${isNaN(barPercent) ? 1 : barPercent}`
      )
    })
  }

  sideScroll = (direction, type) => {
    if (type === "up") {
    } else {
    }
  }

  onClickBar = (e) => {
    this.props.onClickBar(e)
  }

  render() {
    const {
      isLoading,
      lineValue,
      dataAll,
      dataCurrent,
      dataParent,
      loading,
    } = this.props
    const { leyendVisible, bars } = this.state
    const renderBar = bars
    if (isLoading) {
      return <div>Cargando</div>
    }
    return (
      <div className="WeekResponseComponent" id={`DrillDown_${this.id}`}>
        {loading && (
          <div className="loadingCss">
            <div style={{ position: "relative", top: "50%" }}>
              <Spin size="large" />
            </div>
          </div>
        )}
        <div className="WeekResponse">
          {dataParent.id != null && (
            <div
              className="goBack"
              onClick={(e) => this.props.onClickBack(dataParent)}>
              {" "}
              <span>
                {" "}
                <Icon type="left" /> Regresar
              </span>
            </div>
          )}
          {lineValue.value_visible && (
            <div className="leyend">
              <div className="leyend-line">
                <div
                  onClick={() => {
                    this.setState({ leyendVisible: !leyendVisible })
                  }}
                  className="leyend-name color-gray-low"
                  style={
                    !leyendVisible ? { textDecoration: "line-through" } : {}
                  }>
                  Clima Laboral
                </div>
              </div>
            </div>
          )}
          <div className="subContent" id="myChart">
            <div className="axis-days">
              <div>Lu</div>
              <div>Ma</div>
              <div>Mi</div>
              <div>Ju</div>
              <div>Vi</div>
              <div>Sa</div>
              <div>Do</div>
            </div>
            <div className="chart" id="myChart_inner">
              {lineValue.value_visible && leyendVisible && (
                <div
                  className="lineValue"
                  style={{ bottom: lineValue.value_visible }}>
                  {" "}
                </div>
              )}
              {renderBar.map((e, i) => {
                return (
                  <div
                    key={i}
                    className="bar"
                    style={e.childs.length > 0 ? { cursor: "pointer" } : {}}
                    onClick={() =>
                      e.childs.length > 0 ? this.onClickBar(e) : null
                    }>
                    <Tooltip
                      placement="topLeft"
                      overlayClassName="tooltipWhite"
                      title={`${e.employees} colaboradores`}>
                      <div className="bar-line" />
                    </Tooltip>
                    <div className="bar-percent">{e.percent}</div>
                    <div className="bar-name">
                      <Tooltip placement="bottom" title={e.name}>
                        {e.name}
                      </Tooltip>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
          <div className="scrollSide scrollLeft" style={{ left: -18 }}>
            <Icon
              onMouseUp={() => this.sideScroll("left", "up")}
              onMouseDown={() => this.sideScroll("left", "down")}
              style={{ color: "#D2D1D1" }}
              type="left"
            />
          </div>
          <div className="scrollSide scrollRight" style={{ right: -18 }}>
            <Icon
              onMouseUp={() => this.sideScroll("right", "up")}
              onMouseDown={() => this.sideScroll("right", "down")}
              style={{ color: "#D2D1D1" }}
              type="right"
            />
          </div>
        </div>
      </div>
    )
  }
}

WeekResponse.propTypes = {}

export default WeekResponse
